import React, { Component } from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav, NavItem} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'
import { zoomInDown } from 'react-animations';
import { bounceIn } from 'react-animations';
import Radium, {StyleRoot} from 'radium';



const stylesLigh = {
  bounceIn: {
    animation: 'x 5s',
    animationName: Radium.keyframes(bounceIn, 'bounceIn')
  }
}
const stylesLighTwo = {
  bounceIn: {
    animation: 'x 3s',
    animationName: Radium.keyframes(bounceIn, 'bounceIn')
  }
}
const stylesLighThree = {
  bounceIn: {
    animation: 'x 2s',
    animationName: Radium.keyframes(bounceIn, 'bounceIn')
  }
}

class Partenaires extends Component {
  render() {
    return (
    <div>   
    <section id="client-logos" className="wow fadeIn">
            <div className="container">
            <h3 className="nos_serv text-center part">Weekend Bio et Naturel THIES</h3>

               <div className="row flicker">
            
<div className="col-md-4 col-xs-4">
             
                <img src="/assets/img/Weekendbiothies.jpg" alt="" className="Weekendbiothies" /><br/>
               <audio height="60" type="audio/midi" width="100%" src="/assets/audio/weekendbiothies.mp3" volume="60" loop="false" autostart="false" />
               
               <audio controls>
  <source src="/assets/audio/weekendbiothies.mp3" type="audio/ogg" />
</audio>

               </div>
          <div className="col-md-8 col-xs-8">
               <iframe  src="https://flickrembed.com/cms_embed.php?source=flickr&layout=responsive&input=72157713825087518&sort=0&by=album&theme=default&scale=fill&speed=3000&limit=50&skin=default&autoplay=true" scrolling="no" frameborder="0" allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"><p><a  href="https://www.vouchersort.co.uk">Vouchersort</a></p><small>Powered by <a href="https://flickrembed.com">flickr embed</a>.</small></iframe>
              </div>

               </div>


     
            
                </div>
        </section>

        <section id="client-logos" className="wow fadeIn ptb ptb-sm-80">
            <div className="container">
            <h3 className="nos_serv text-center part">Ils nous font confiance</h3>

               <div className="row">
                  <div className="col-md-3"><a href="https://www.isra.sn/" target="blank"><img src="/assets/img/logos/isra.png" alt="" className="part_logo citeiz" /></a></div>
                  <div className="col-md-3"><a href="https://societegenerale.sn/" target="blank"><img src="/assets/img/logos/sgbs.png" alt="" className="part_logo bank" /></a>
                    <h4 className="maison">La maison de la PME</h4>
                  </div>
                  <div className="col-md-3"><a href="https://www.orabank.net/fr" target="blank"><img src="/assets/img/logos/orabank.jpg" alt="" className="part_logo"/></a></div>
                  <div className="col-md-3"><a href="https://www.abcobourse.com/" target="blank"><img src="/assets/img/logos/abcobouse.jpg" alt="" className="part_logo"/></a></div>
                </div>
                <div className="row">
                  <div className="col-md-4"><img src="/assets/img/logos/ue.jpg" alt="" className="part_logo"/><br/><p className="union"><b>Union Européenne</b></p></div>
                  <div className="col-md-4"><a href="https://www.afd.fr/fr" target="blank"><img src="/assets/img/logos/Logo-AFD.jpg" alt="" className="part_logo afd" /></a></div>
                  <div className="col-md-4"><h4 className="program">Programme National de Biogaz <br/>PNB-SN</h4></div>
                  </div>


     
            
                </div>
        </section>
    </div>
    )
  }
}
export default Partenaires;


// WEBPACK FOOTER //
// ./src/components/partners.jsx